<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col px-0 custom-form-main-label">
        {{ $store.translate('edit_shift')}}{{title}} <a style="color:inherit;" href="#" @click="toggleExpand"><i class="icon-cog2"></i></a>
      </div>
    </div>
    <div class="row" v-show="expanded == true">
      <div class="col-12 p-0">
        <form id="createShiftTimeForm" name="createShiftTimeForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('start_time')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="starttime" type="text" id="txtstarttime" v-bind:placeholder="defaultStartTime" maxlength="50" name="starttime" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('end_time')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="endtime" type="text" id="txtendtime" v-bind:placeholder="defaultEndTime" maxlength="50" name="endtime" class="form-control" />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="updateLocationShift" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
              <button @click="deleteShift" type="button" class="btn skin btn-danger pull-right mr-2"><i class="icon-cog5 mr-2"></i> {{$t('delete')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "location-shifts-time",
    components: {

    },
    props: {
      locationshiftId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        starttime: "",
        endtime: "",
        isStartTimeValid: true,
        isEndTimeValid: true,
        shifts: [],
        defaultStartTime: "",
        defaultEndTime: "",
        title: "",
        expanded:false
      };
    },
    methods: {
      toggleExpand() {
        this.expanded = !this.expanded;
      },
      getId() {
        return this._uid;
      },
      deleteShift() {
        var msg = this.$t('confirm_delete')
        if (confirm(msg)) {
          this.$emit('event-edittime', 'delete');
        }        
      },
      async updateLocationShift() {

        if (!$('#createShiftTimeForm').valid())
          return false;
        this.isStartTimeValid = true;
        this.isEndTimeValid = true;
        var time = new RegExp('^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$');
        if (this.starttime != "") {
          if (time.test(this.starttime) === false) {
            this.isStartTimeValid = false;
            alert("Start time is not valid.");
          }
        }

        if (this.endtime != "") {
          if (time.test(this.endtime) === false) {
            this.isEndTimeValid = false;
            alert("End time is not valid.");
          }
        }
        
        if (!this.isEndTimeValid || !this.isStartTimeValid) {
          return false;
        }

        var request = {
          LocationShiftId: this.locationshiftId, StartTime: this.starttime, EndTime: this.endtime
        };

        try {
          var response = await this.$http.post(
            '/api/Admin/v1/Location/Shift',
            request
          ).then(async response => {
            this.$emit('event-edittime', 'Time');
          });

        } catch (err) {
          alert(err);
        }
      },
      async getLocationShift(locationshiftId) {
        try {
          this.locationshiftId = locationshiftId;
          this.$http.get('Location/Shift/' + locationshiftId).then(async response => {
            var shift = response.data;
            this.title = " " + shift.ShiftName + " " + this.$t(shift.Day.toLowerCase()) + " " + this.$t('at') + " " + shift.LocationName;

            this.starttime = shift.StartTime;
            this.endtime = shift.EndTime;

            for (var i = 0; i < this.shifts.length; i++) {
              if (this.shifts[i].SiteShiftId == shift.SiteShiftId) {
                this.defaultStartTime = this.shifts[i].StartTime;
                this.defaultEndTime = this.shifts[i].EndTime;
              }
            }

            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async getShifts() {
        try {
          this.$http.get('/api/Admin/v1/SiteShifts').then(async response => {
            this.shifts = response.data;
            
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
    },
    watch: {
      locationshiftId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getLocationShift(newVal);
        } else {
          this.starttime = '';
          this.endtime = '';
        }
      }
    },
    mounted() {

      this.getShifts();

      _componentValidation('#createShiftTimeForm');
      if (this.locationshiftId > 0) {
        this.getLocationShift(this.locationshiftId);
      }
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/location-shifts-time.vue